import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, Facebook, Twitter, Instagram, Linkedin, Send, ArrowUp } from "lucide-react";
import { NAV_LINKS, SERVICES } from "../mock/mock";
import { useContact } from "../context/ContentContext";
import { useToast } from "../hooks/use-toast";
import { subscribe as subscribeApi } from "../lib/api";

const socialIcons = { facebook: Facebook, twitter: Twitter, instagram: Instagram, linkedin: Linkedin };

export default function Footer() {
  const [email, setEmail] = useState("");
  const { toast } = useToast();
  const CONTACT = useContact();

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await subscribeApi(email);
      toast({ title: "Subscribed!", description: `${email} is now on our list.` });
      setEmail("");
    } catch {
      toast({ title: "Subscription failed", description: "Please try again." });
    }
  };

  return (
    <footer className="bg-homi-black text-white/65">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="inline-block bg-white rounded-xl p-3 mb-5">
              <img src="/emb-logo.png" alt="EMB - Efficient Master Builders" className="h-14 w-auto" />
            </div>
            <p className="text-sm leading-relaxed mb-5">Efficent Master Builders — quality building, renovation and repair. Craftsmanship you can trust since 2004.</p>
            <div className="flex gap-3">
              {CONTACT.socials.map((s) => {
                const Icon = socialIcons[s];
                return (
                  <a key={s} href="#" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-homi-gold hover:text-homi-black flex items-center justify-center transition-colors">
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="text-white font-heading font-bold text-lg mb-5">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.path}><Link to={l.path} className="hover:text-homi-gold transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-bold text-lg mb-5">Our Trades</h4>
            <ul className="space-y-3 text-sm">
              {SERVICES.map((s) => (
                <li key={s.title}><Link to="/homi/services" className="hover:text-homi-gold transition-colors">{s.title}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-bold text-lg mb-5">Get In Touch</h4>
            <ul className="space-y-4 text-sm mb-6">
              <li className="flex items-center gap-3"><Phone className="w-5 h-5 text-homi-gold shrink-0" /> {CONTACT.phone}</li>
              <li className="flex items-center gap-3"><Mail className="w-5 h-5 text-homi-gold shrink-0" /> {CONTACT.email}</li>
              <li><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-homi-gold transition-colors"><MessageCircle className="w-5 h-5 text-homi-gold shrink-0" /> WhatsApp us</a></li>
            </ul>
            <form onSubmit={subscribe} className="flex">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email"
                className="flex-1 min-w-0 bg-white/10 border border-white/15 rounded-l-lg px-4 py-2.5 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-homi-gold" />
              <button type="submit" className="bg-homi-gold hover:bg-homi-goldDark rounded-r-lg px-4 flex items-center justify-center transition-colors"><Send className="w-4 h-4 text-homi-black" /></button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <p>&copy; {new Date().getFullYear()} Efficent Master Builders. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-homi-gold transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-homi-gold transition-colors">Terms of Service</a>
            <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="w-9 h-9 rounded-lg bg-homi-gold hover:bg-homi-goldDark flex items-center justify-center transition-colors">
              <ArrowUp className="w-4 h-4 text-homi-black" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
